export const MEETING_CHAT_LINK = {
  MALE: 'https://link.bachelorapp.net/Ys27/aboutchatmale',
  FEMALE: 'https://link.bachelorapp.net/Ys27/aboutchatfemale'
};
export const BEFORE_REMATCHING_TIME_LINK =
  'https://bachelorapp.zendesk.com/hc/ja/articles/4404733325209-%E6%BA%80%E5%93%A1%E5%BE%A1%E7%A4%BC%E3%81%A8%E3%81%AF';
export const AFTER_REMATCHING_TIME_LINK =
  'https://bachelorapp.zendesk.com/hc/ja/articles/4404741252505';
export const USER_PREMIUM_PLAN_FOR_MALE_LINK =
  'https://bachelordate.onelink.me/Ys27/bjf5kydx';
export const ABOUT_CHANGE_PLAN_URL =
  'https://bachelordate.onelink.me/Ys27/cl1pc5o7';
export const DETAIL_ON_DATE_TICKET_LINK =
  'https://bachelordate.onelink.me/Ys27/7875x8xj';
export const MATCHING_MECHANISM_LINK =
  'https://bachelordate.onelink.me/Ys27/0ge85308';
export const HOW_BATCHER_RATIO_WORKS_LINK =
  'https://bachelordate.onelink.me/Ys27/l0tfralo';
export const ZENDESK_REMATCHING_3PM_LINK =
  'https://bachelordate.onelink.me/Ys27/l0tfralo';
export const REPORT_WORK_LINK = 'https://bachelordate.onelink.me/Ys27/6zi3wy33';
export const ZENDESK_BACHELOR_NOT_RENEW_LINK =
  'https://bachelordate.onelink.me/Ys27/xyscsund';
export const ZENDESK_BACHELOR_RATE_LINK =
  'https://link.bachelorapp.net/Ys27/aboutratefemale';
export const HREF_EMAIL_RESERVATION = {
  MALE: 'https://link.bachelorapp.net/Ys27/fsroqppk',
  FEMALE: 'https://bachelordate.onelink.me/Ys27/mns1bdxd'
};
export const CANCELLATION_CHARGE_LINK = {
  MALE: 'https://bachelordate.onelink.me/Ys27/o8ikgcfr',
  FEMALE: 'https://bachelordate.onelink.me/Ys27/oi3jutg2'
};
export const VIDEO_DATE_SUGGESTION = {
  MALE: 'https://bachelordate.onelink.me/Ys27/hphll6g9',
  FEMALE: 'https://bachelordate.onelink.me/Ys27/5u85lydc'
};
export const FEED_BACK_UNSUITABLE_LINK = {
  MALE: 'https://bachelordate.onelink.me/Ys27/lpikvmsw',
  FEMALE: 'https://bachelordate.onelink.me/Ys27/syxe7fsu'
};
export const ABOUT_CREDIT_CARD_REGISTRATION_LINK = {
  MALE: 'https://bachelordate.onelink.me/Ys27/e2xuawdd',
  FEMALE: 'https://bachelordate.onelink.me/Ys27/v9himv8g',
  ODD_MALE: 'https://bachelordate.onelink.me/Ys27/a7mtvted',
  EVEN_MALE: 'https://bachelordate.onelink.me/Ys27/o56wdkhm'
};
export const NORMAL_INBOX_LINK = {
  MALE: 'https://bachelordate.onelink.me/Ys27/70pvrb8n',
  FEMALE: 'https://bachelordate.onelink.me/Ys27/5f7n1whn'
};
export const SUCCESSFUL_DATING_LINK = {
  MALE: 'https://bachelordate.onelink.me/Ys27/lpikvmsw',
  FEMALE: 'https://bachelordate.onelink.me/Ys27/syxe7fsu'
};
export const FREQUENTLY_ASKED_QUESTIONS_LINK = {
  MALE: 'https://bachelordate.onelink.me/Ys27/lgx7iswy',
  FEMALE: 'https://bachelordate.onelink.me/Ys27/ah2jnrok'
};
export const NEW_NEW_FLOW_FEMALE_LINK =
  'https://bachelordate.onelink.me/Ys27/15b1n3qx';
export const SUPPORT_EMAIL_SETTING_LINK = 'https://bachelordate.onelink.me/Ys27/ygl9m8j6';
export const SUPPORT_BACHELOR_FE_LINK = 'https://bachelordate.onelink.me/Ys27/ah2jnrok';
export const SUPPORT_BACHELOR_MA_LINK = 'https://bachelordate.onelink.me/Ys27/lgx7iswy';
export const FEMALE_BUY_COUPON_LINK = 'https://r0hlgihg.paperform.co';
export const SUPPORT_SMS_LOGIN_LINK = 'https://bachelordate.onelink.me/Ys27/wcipqw4b';
export const FEMALE_RANK_LINK = 'https://bachelordate.onelink.me/Ys27/2aik0752';
export const REQUEST_COMMIT_OPTION_POPUP_LINK = 'https://bachelordate.onelink.me/Ys27/tewy35d5';
